import React, { Component } from 'react'
import { connect } from 'react-redux'
import { identity, partial } from 'lodash'

import PaintSummary from 'components/PaintSummary'
import PaintColorSwapModal from 'components/PaintColorSwapModal'

import { getFaceVM } from 'state/viewModels'
import * as actions from 'ducks/modules/customize'
import PaintFillChooser from 'components/PaintFillChooser'
import InitialsChooser from 'components/InitialsChooser'
import StampChooser from 'components/StampChooser'
import NavWarning from 'containers/NavWarning'
import { TrackedButtonLink } from 'components/Buttons'

import CustomModal from 'components/CustomModal'

export class FaceForm extends Component {
  constructor() {
    super();
    this.state = {
      currentPaintFill: null,
      modal: false,
	  largeStampModal: false,
      initialsChecked: false,
      stampsChecked: false,
      closeButton: false,
      modalContent: '',
	  tempStampId: 0
    };
  }
  setCurrentPaintFill(paint) {
    let colorObj = {};
    colorObj.color = paint;
	
	
	
    if(!paint)
      colorObj = paint;
    this.setState({currentPaintFill: colorObj});
  }
  
  //check if selected stamp requires initials to be disabled
  setStampOptions(locId, fieldName, stampId) {
	  var hasFaceToeInitials = false;
	  var allStamps = this.props.stampsLocations[0].stamps;
	  var curStamp = {};
	  let y = 0;
	  for(y = 0; y < allStamps.length; y++) {
		if(allStamps[y].id == stampId) {
			curStamp = allStamps[y];
			break;
		}
	  }
	  
	  let r = 0;
	  for(r = 0; r < allStamps.length; r++) {
		if(this.props.initials.length > 0 && this.props.initials[r].loc.parameterKey == 'faceText') {
			hasFaceToeInitials = true;
			break;
		}
	  }
	  	  
	  if(!this.props.faceStampOrInitialsOnly && hasFaceToeInitials && curStamp.disableInitials) {			
		this.setState({ modalContent: 'The stamp you selected does not allow initials to be added to the face. Would you like to proceed?', tempStampId: stampId, stampsChecked: true, initialsChecked: false });
		this.toggleLargeStampModal();
	  } else {	  
		this.props.onSelectStamp(locId, fieldName, stampId);
	  }
  }
  
  //check if this putter only allows Stamp Or Initials
  setStampCheckOptions(value, i) {
    if (!this.props.faceStampOrInitialsOnly)
    return;
    if (value == false) {
        this.setState({ stampsChecked: false, initialsChecked: false });
        return;
    }
    
    var stampSelected = false;
    var initialsSelected = false;
    var stamp = this.props.stampsLocations[0];
    var initials = this.props.initials[0];        

    if ((stamp !== null && stamp !== undefined) && (stamp.selected !== null && stamp.selected !== undefined)) {
		console.log(JSON.stringify(stamp));
        if (stamp.selected.enabled) {
            stampSelected = true;
        }
    }
    if ((initials !== null && initials !== undefined) && (initials.selected !== null && initials.selected !== undefined)) {
        if (initials.selected.enabled) {
            initialsSelected = true;
              
        }
    }
      
    if (this.state.initialsChecked || this.state.stampsChecked || stampSelected || initialsSelected) {
        this.setState({ modalContent: 'By selecting Stamps, your Initials selections will be removed. Would you like to proceed?' });
        this.selectModal();
    }

    if (value == true) {
        this.setState({ stampsChecked: true, initialsChecked: false });
    }          
  }

  //check if this putter only allows Stamp Or Initials
  setInitialCheckOptions(value1, value2, i) {
    var stamp = this.props.stampsLocations[0];
	console.log('this.state.stampsChecked1=' + this.state.stampsChecked);
	
	var largeStampSelected = false;	
    if (stamp !== undefined && stamp !== null && stamp.selected !== undefined && stamp.selected !== null) {
        if (stamp.selected.enabled) {
            stampSelected = true;
			if(stamp.selected.stamp !== undefined && stamp.selected.stamp.disableInitials) {
				largeStampSelected = true;	
			}
        }
    }
	
	if (!largeStampSelected && !this.props.faceStampOrInitialsOnly)
          return;

    if (value2 == false) {
        this.setState({ initialsChecked: false, stampsChecked: false });
        return;
    }        
    console.log('this.state.stampsChecked2=' + this.state.stampsChecked);
    var stampSelected = false;
    var initialsSelected = false;
    
    var initials = this.props.initials[0];

    if ((initials !== null && initials !== undefined) && (initials.selected !== null && initials.selected !== undefined)) {
        if (initials.selected.enabled) {
            initialsSelected = true;

        }
    }      
console.log('this.state.stampsChecked3=' + this.state.stampsChecked);
    if (this.state.initialsChecked || this.state.stampsChecked || stampSelected || initialsSelected || largeStampSelected) {
        this.setState({ modalContent: 'By selecting Initials, your Stamps selections will be removed. Would you like to proceed?' });
        this.selectModal();
    }

    if (value2 == true) {
        this.setState({ initialsChecked: true, stampsChecked: false });
    }      
  }

  componentWillMount(){
    this.props.selectView('FS') 
  }

  selectModal = (info) => {
    this.setState({modal: !this.state.modal}) 
  } 
  
  toggleLargeStampModal = (info) => {
    this.setState({largeStampModal: !this.state.largeStampModal}) 
  } 

  handleChange(e) {   
   
    if (this.state.initialsChecked && !this.state.stampsChecked) {
        var stamp = this.props.stampsLocations[0];
        this.props.onSelectStamp(stamp.loc.id, 'enabled', false);
    }
    if (this.state.stampsChecked && !this.state.initialsChecked) {
        var initials = this.props.initials[0];        
        this.props.onInitialsFieldChange(initials.loc.label, 'enabled', false);     
    }
        
    this.setState({ modal: false })        
  }

  handleChangeCancel(e) {   
    
    if (this.state.initialsChecked && !this.state.stampsChecked) {
        var initials = this.props.initials[0];
        this.props.onInitialsFieldChange(initials.loc.label, 'enabled', false);
    }
    if (this.state.stampsChecked && !this.state.initialsChecked) {
            
        var stamp = this.props.stampsLocations[0];
        this.props.onSelectStamp(stamp.loc.id, 'enabled', false);
    }

    this.setState({ modal: false })
  }  


  handleLargeStampChange(e, stampId) {   
	var initials = this.props.initials[0];        
	this.props.onInitialsFieldChange(initials.loc.label, 'enabled', false);     
	var stampLoc = this.props.stampsLocations[0];
	this.props.onSelectStamp(stampLoc.loc.id, 'stampId', stampId);
    this.setState({ largeStampModal: false, tempStampId: 0 })        
  }
  
  handleLargeStampChangeCancel(e) {   
    
    if (this.state.stampsChecked) {
            
        var stamp = this.props.stampsLocations[0];
        this.props.onSelectStamp(stamp.loc.id, 'enabled', false);
		this.props.onSelectStamp(stamp.loc.id, 'enabled', true);
    }

    this.setState({ largeStampModal: false, tempStampId: 0 })
  }


  handleChangeCancel(e) {   
    
    if (this.state.initialsChecked && !this.state.stampsChecked) {
        var initials = this.props.initials[0];
        this.props.onInitialsFieldChange(initials.loc.label, 'enabled', false);
    }
    if (this.state.stampsChecked && !this.state.initialsChecked) {
            
        var stamp = this.props.stampsLocations[0];
        this.props.onSelectStamp(stamp.loc.id, 'enabled', false);
    }

    this.setState({ modal: false })
  }  


  render = () => (<div>
    <CustomModal showDefaultCloseButton={this.state.closeButton} displayModal={this.state.largeStampModal} closeModal={this.selectModal}>
          <div><p>{this.state.modalContent}</p><button onClick={e => this.handleLargeStampChange(e, this.state.tempStampId)}>Ok</button><button onClick={e => this.handleLargeStampChangeCancel(e)}>Cancel</button></div>
      <span className="custom-modal-close" onClick={e => this.handleLargeStampChangeCancel(e)}>&times;</span>
    </CustomModal>
	<CustomModal showDefaultCloseButton={this.state.closeButton} displayModal={this.state.modal} closeModal={this.selectModal}>
          <div><p>{this.state.modalContent}</p><button onClick={e => this.handleChange(e)}>Ok</button><button onClick={e => this.handleChangeCancel(e)}>Cancel</button></div>
      <span className="custom-modal-close" onClick={e => this.handleChangeCancel(e)}>&times;</span>
    </CustomModal>
    <div className="customize-form-header">Face</div>
	  {this.props.paintFillLocations.length === 0 && this.props.initials.length === 0 && this.props.stampsLocations.length === 0 &&
      <div className="customize-form-section">
        <div className="instructional-text">
          There are no customization options on this view.
        </div>
      </div>
    }
    <div className="customize-form-section">
      {this.props.paintFillLocations.length > 0 && 
        <div className="customize-form-section-header">Select Colors</div>
      }
      {/*If paintFill id is not 6 (new paintfill) then link them back to finish to select a customize color option*/}
      {this.props.paintFillLocations.length > 0 && this.props.paintFill.id !== 6 &&
        <div className="customize-form-section-content">
          <div className="enable-paintfill-question">Did you want to customize your colors?</div>
          <div className="enable-paintfill-link" type="button" onClick={() => this.props.onEnablePaintFill('paintFill', 6)}>
            Enable Paintfill
            {!(this.props.buyAPutter && this.props.buyAPutter.selected) && 
              <span> ${this.props.paintFillPrice}</span>
            }
          </div>
          <div className="clearfix"></div>
        </div>
      }
      {this.props.paintFillLocations.length > 0 && this.props.paintFill.id === 6 &&
        <div className="customize-form-section-content">
          <div className="paintfill-tools"> 
            <PaintSummary 
              paints={this.props.paintSummary} 
              maxPaintfillColors={this.props.maxPaintfillColors} 
              onClick={ (paint) => this.setCurrentPaintFill(paint) }/>
            <div className="reset-colors-link" type="button" onClick={() => this.props.resetPaintFills()}>
              Reset to Original
            </div>
            <div className="reset-colors-link" type="button" onClick={() => this.props.clearPaintFills()}>
              Clear All
            </div>
          </div>
          {
            this.props.paintFillLocations.map((loc, index) => (
              <PaintFillChooser key={loc.loc.id}
                loc={loc.loc}
                paints={loc.paints}
                selectedPaint={loc.selected}
				        isError={this.props.showValidationWarnings && !loc.valid}
                onSelectPaintFill={(paint) => this.props.onSelectPaintFill(loc.loc.id, paint.id)}
              />
            ))
          }
          <div className="clearfix"></div>
        </div>
      }
    </div>
    <div className="customize-form-section">
      {this.props.initials.length > 0 && 
        <div className="customize-form-section-header">Select Initials</div>
      }
      {this.props.initials.length > 0 && 
        <div className="customize-form-section-content">
		  {
            this.props.initials.map(i => (
              <InitialsChooser key={i.loc.id}
				id="initials-face"
                initials={i.loc}
                selected={i.selected}
                personalizationStyles={i.styleOptions}
                paintLoc={i.paint.loc}
                paints={i.paint.paints}
                selectedPaint={i.paint.selected}
                isError={(this.props.showValidationWarnings && !i.valid)}
                isPaintError={this.props.showValidationWarnings && !i.paint.valid}
                onFieldChange={partial(this.props.onInitialsFieldChange, i.loc.label)}
                onFieldChangeAdditionalOptions={(value1, value2) => { this.setInitialCheckOptions(value1, value2, i) }}                          
                onSelectPaintFill={(locid, paintid) => this.props.onSelectPaintFill(locid, paintid)}
                buyAPutter={this.props.buyAPutter}
              />
            ))
          }
        </div>
      }
    </div>
    {this.props.faceStampOrInitialsOnly &&
        <div className="customize-form-section">
            <div className="customize-form-section-header">OR</div>

            {this.props.initials.length > 0 &&
                <div>{this.props.initials[0].selected.enabled}</div>
            }
        </div>
    }
    <div className="customize-form-section">
      {this.props.stampsLocations.length > 0 && 
        <div className="customize-form-section-header">Select Stamps</div>
      }
      {this.props.stampsLocations.length > 0 && 
        <div className="customize-form-section-content">
          {
            this.props.stampsLocations.map(i => (
              <StampChooser key={i.loc.id}
                stampLoc={i.loc}
                enabled={i.selected && i.selected.enabled}
                selectedStamp={i.selected && i.selected.stamp}
                stamps={i.stamps}
                onCheck={(value) => { this.props.onSelectStamp(i.loc.id, 'enabled', value); this.setStampCheckOptions(value, i) }}
                onSelectStamp={(value) => this.setStampOptions(i.loc.id, 'stampId', value)}
                paintLoc={i.paint.loc}
                selectedPaint={i.paint.selected}
                paints={i.paint.paints}
                isError={this.props.showValidationWarnings && !i.valid}
                isPaintError={this.props.showValidationWarnings && !i.paint.valid}
                onSelectPaintFill={(locid, paintid) => this.props.onSelectPaintFill(locid, paintid)}
                buyAPutter={this.props.buyAPutter}
              />
            ))
          }
        </div>
      }
    </div>
    <div className="customize-form-section">
      <TrackedButtonLink trackingData="Next:Back" className="next" to="back">next: back</TrackedButtonLink>
    </div>
    <NavWarning when={!this.props.validation.valid} 
      message="Please complete all selections above before going to another page."/>

    <PaintColorSwapModal 
      headerTitle="Change Color"
      headerText="If you select a new color here, we will apply that color to all the areas that have this color currently selected."
      colorSelectedText="Current Color"
      colorToSelectText="Select a new color:"
      currentPaintFill={this.state.currentPaintFill}
      allPaintColors={this.props.allPaintColors}
      replacePaint={this.props.replacePaint}
      cancel={() => this.setCurrentPaintFill(null)}
      className="paint-swapper"
      paintSwapValid={this.props.paintSwapValid}
    />
  </div>)
}

FaceForm.defaultProps = {
  paintFillLocations: [],
  initials: [],
  stampsLocations: [],
  onSelectPaintFill: identity,
  onSelectStamp: identity,
  onInitialsFieldChange: identity,
  onEnablePaintFill: identity,
};

const mapStateToProps = (state, ownProps) => {
  var p = { ...getFaceVM(state.customize, false) }
  p.showValidationWarnings = state.app.blockedNavigation && !p.validation.valid;

  return p;
}
const mapDispatchToProps = {
  onSelectPaintFill: actions.selectPaintFill,
  onInitialsFieldChange: actions.changeInitials,
  onSelectStamp: actions.selectStamp,
  selectView: actions.selectView,
  onEnablePaintFill: actions.selectField,
  resetPaintFills: actions.resetPaintFills,
  replacePaint: actions.replacePaint,
  clearPaintFills: actions.clearPaintFills,
}

export default connect(mapStateToProps, mapDispatchToProps)(FaceForm);